export default __webpack_public_path__ + "static/media/1905.37a27c3e.png";